import aa from 'search-insights'

/**
 * Initializes search-insights once on the client, opted out (no events) and without a cookie.
 * Dependes on functional consent (C0003).
 * @see `plugins/algolia-insights-consent.client.ts`: checks cookie consent change and re-inits Algolia insights.
 */
export default defineNuxtPlugin({
  name: 'algolia-insights',
  setup() {
    const runtimeConfig = useRuntimeConfig()
    const appId = runtimeConfig.public.algolia?.applicationId
    const apiKey = runtimeConfig.public.algolia?.apiKey

    if (!appId || !apiKey) {
      return
    }

    const initializedFor = (window as any).ALGOLIA_INSIGHTS_INITIALIZED_FOR_APP
    if (initializedFor === appId) {
      return
    }

    aa('init', {
      appId,
      apiKey,
      userHasOptedOut: true,
      useCookie: false,
    })
    ;(window as any).ALGOLIA_INSIGHTS_INITIALIZED_FOR_APP = appId
  },
})
